<!--LevelType:新高考报告等级类型选择页面 2025/5/15 15:46:21 XiJiGuo-->
<template lang="">
  <div>
    <div class="top">
      <gao-kao-step :active="0"></gao-kao-step>
    </div>
    <div class="card-container">
      <el-row v-for="(thData, thIndex) in tableData" :key="thIndex">
        <el-col :span="8" v-for="(item, index) in thData" :key="index">
          <div v-if="item.newTip" @click="handleClick(item.areaCode, true)" class="card" :style="item.customStyle">
            <div class="content" :style="item.areaNameStyle">{{ examEnum[item.areaCode].desc + item.areaName }}</div>
            <div class="extra">
              {{ item.areaDesc }}（新版）
              <el-tooltip :content="item.newTip" placement="top">
                <span class="el-icon-question"></span>
              </el-tooltip>
              <span class="jump-old" @click.stop="handleClick(item.areaCode)">进入旧版</span>
            </div>
          </div>
          <div v-else @click="handleClick(item.areaCode)" class="card" :style="item.customStyle">
            <div class="content" :style="item.areaNameStyle">{{ examEnum[item.areaCode].desc + item.areaName }}</div>
            <div class="extra">
              {{ item.areaDesc }}
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>
<script>
import exam_enum from '@/utils/exam_enum'
import GaoKaoStep from './components/GaoKaoStep.vue'
export default {
  name: 'LevelType',
  components: {
    GaoKaoStep
  },
  data () {
    return {
      chunkSize: 3,
      examEnum: exam_enum.examEnum,
      gaoKaoAreaList: [
        {
          areaCode: 'JIANG_SU',
          areaName: '、辽宁、沈阳、湖南等8个省份',
          areaDesc: '3+1+2',
          newTip: '新版根据总分划线推算单科有效分；旧版根据单科划线推算总分有效分',
          areaNameStyle: "font-size:18px",
          customStyle: 'background:linear-gradient(180deg,rgba(55,220,255,1) 0%,rgba(91,152,251,1) 100%);box-shadow:2px 4px 10px rgba(57,216,255,0.2);'
        },
        {
          areaCode: 'ZHE_JIANG',
          areaName: '新高考',
          areaDesc: '21档',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(360deg,rgba(251,104,104,1) 0%,rgba(254,155,111,1) 100%);box-shadow:2px 4px 10px rgba(251,104,104,0.2);'
        },
        {
          areaCode: 'SHANG_HAI',
          areaName: '新高考',
          areaDesc: '11档',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(180deg,rgba(255,194,122,1) 0%,rgba(251,163,103,1) 100%);box-shadow:2px 4px 10px rgba(254,177,113,0.2);'
        },
        {
          areaCode: 'SHAN_DONG',
          areaName: '新高考',
          areaDesc: '8档',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(180deg,rgba(97,217,176,1) 0%,rgba(23,194,137,1) 100%);box-shadow:2px 4px 10px rgba(51,203,152,0.2);'
        },
        {
          areaCode: 'BEI_JING',
          areaName: '新高考',
          areaDesc: '21档',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(180deg,rgba(158,187,255,1) 0%,rgba(123,123,255,1) 100%);box-shadow:2px 4px 10px rgba(139,152,255,0.2);'
        },
        {
          areaCode: 'TIAN_JIN',
          areaName: '新高考',
          areaDesc: '21档',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(180deg,rgba(55,220,255,1) 0%,rgba(91,152,251,1) 100%);box-shadow:2px 4px 10px rgba(57,216,255,0.2);'
        },
        {
          areaCode: 'HE_NAN',
          areaName: '新高考',
          areaDesc: '3+大综合',
          areaNameStyle: "",
          customStyle: 'background:linear-gradient(180deg,rgba(55,220,255,1) 0%,rgba(91,152,251,1) 100%);box-shadow:2px 4px 10px rgba(57,216,255,0.2);'
        },
      ],
      loading: false
    }
  },
  computed: {
    tableData () {
      const result = []
      for (let i = 0; i < this.gaoKaoAreaList.length; i += this.chunkSize) {
        result.push(this.gaoKaoAreaList.slice(i, i + this.chunkSize))
      }
      return result
    }
  },
  methods: {
    async handleClick (type, isNew = false) {
      this.loading = true
      sessionStorage.removeItem('XGKSetting')
      const url = `/exam/gaokao/chooseExam${isNew ? 'New' : ''}?examType=${this.examEnum[type].code}`
      await this.$router.replace(url)
      this.loading = false
    }
  }
}
</script>
<style lang="scss" scoped>
.top {
  background: rgba(255, 255, 255, 1);
  opacity: 1;
  border-radius: 6px;
  padding: 15px;
}

.top .label {
  text-align: center;
  font-size: 20px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  line-height: 29px;
  color: rgba(51, 51, 51, 1);
  opacity: 1;
  margin-bottom: 10px;
}

.card-container {
  padding-bottom: 40px;
}

.card-container .card {
  margin-left: 20px;
  margin-right: 20px;
  margin-top: 30px;
  min-width: 300px;
  height: 170px;
  opacity: 1;
  border-radius: 10px;
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s linear;
  position: relative;
}

.card-container .card:hover {
  transform: translateY(-10px);
  box-shadow: 0px 6px 16px rgba(18, 157, 175, 0.2);
}

.card-container .card .content {
  font-size: 24px;
  font-family: Source Han Sans SC;
  font-weight: bold;
  line-height: 27px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}

.card-container .card .extra {
  margin-top: 10px;
  font-size: 20px;
  font-family: Source Han Sans SC;
  font-weight: 400;
  line-height: 29px;
  color: rgba(255, 255, 255, 1);
  opacity: 1;
}

.card-container .card .extra .jump-old {
  position: absolute;
  bottom: 10px;
  font-size: 12px;
  right: 20px;
  background-color: #2877ff;
  padding: 0 8px;
  border-radius: 4px;
}
</style>
